import { Heart, ShieldCheck, LineChart, Users } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

interface ValueProp {
  icon: LucideIcon;
  title: string;
  body: string;
}

const PROPS: ValueProp[] = [
  {
    icon: Heart,
    title: 'Genuine attention',
    body: 'Your campaign reaches people who chose to be there — leaning in, not scrolling past.',
  },
  {
    icon: ShieldCheck,
    title: 'Brand-safe by default',
    body: 'You stay in control of the company you keep. Tell us what fits and what doesn’t — we handle the rest.',
  },
  {
    icon: LineChart,
    title: 'Results you can show',
    body: 'Reach, engagement, and outcomes in clear language — so the next campaign meeting practically writes itself.',
  },
  {
    icon: Users,
    title: 'A team beside you',
    body: 'Real people to plan with, brief, and adjust on the fly. Self-serve when you want it, hands-on when you need it.',
  },
];

export function WhyAdspert() {
  return (
    <section className="border-t border-border-soft bg-surface-sunken/40">
      <div className="mx-auto max-w-container-lg px-4 py-24 sm:px-6 lg:px-8 lg:py-28">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-semibold uppercase tracking-caps text-primary">
            Why brands choose us
          </span>
          <h2 className="mt-3 font-display text-4xl leading-display tracking-display text-ink sm:text-5xl">
            A calmer, smarter way to advertise.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-x-9 gap-y-12 sm:grid-cols-2 lg:grid-cols-4">
          {PROPS.map(({ icon: Icon, title, body }) => (
            <div key={title} className="flex flex-col items-start">
              <span className="flex h-12 w-12 items-center justify-center rounded-md border border-border-soft bg-surface text-primary">
                <Icon className="h-6 w-6" aria-hidden />
              </span>
              <h3 className="mt-5 font-display text-xl leading-display text-ink">
                {title}
              </h3>
              <p className="mt-2.5 text-base leading-body text-ink-secondary">{body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
